import clientAuth from "../clientAuth";
export default {
    index: (userData) => clientAuth.post("customer/database", { json: userData }),
}